import { useEffect, useState } from "react";
import useAttachment from "../../../hooks/useAttachment";
import useLoading from "../../../hooks/useLoading";
import ContentLoader from "../ContentLoader";

import FeaturedImage from "../FeaturedImage";

interface Props {
  name: string;
  label: string;
  value: any;
  setValue: any;
  register: any;
}

const ImageField: React.FC<Props> = ({
  name,
  label,
  value,
  setValue,
  register,
}) => {
  const [state, setState] = useState(value);
  const { loading, changeLoading } = useLoading();
  const { attachmentsGet } = useAttachment("attachments", "attachment");

  async function fetchAttachment() {
    if (typeof value === "string" && value.length > 0) {
      const attachment = await attachmentsGet({ id: value });
      setState(attachment);
    }

    changeLoading(false);
  }

  useEffect(() => {
    register(name);
    fetchAttachment();

    // eslint-disable-next-line
  }, []);

  return loading ? (
    <ContentLoader />
  ) : (
    <FeaturedImage
      label={label}
      attachment={state}
      changeAttachment={(attachment: any) => {
        setValue(name, attachment);
        setState(attachment);
      }}
    />
  );
};

export default ImageField;
